import React from 'react';
import { Tag } from 'antd';
import { formatPartnerStatus } from '../../utils/helpers';

const PartnerStatusBadge = ({ status, ...props }) => {
  const { label, color } = formatPartnerStatus(status);

  return (
    <Tag color={color} {...props}>
      {label}
    </Tag>
  );
};

export default PartnerStatusBadge;
